import React from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import Icon from '@mdi/react';
import { mdiLogout } from '@mdi/js';
import { adminTheme } from '../styles/adminTheme';

const HeaderContainer = styled.header`
  height: ${adminTheme.spacing.header}px;
  background: ${adminTheme.colors.headerBg};
  border-bottom: 1px solid ${adminTheme.colors.border};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  flex-shrink: 0;
`;

const Breadcrumb = styled.div`
  font-size: 13px;
  color: ${adminTheme.colors.textSecondary};

  span {
    color: ${adminTheme.colors.text};
    font-weight: 600;
  }
`;

const UserArea = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Username = styled.span`
  font-size: 12px;
  color: ${adminTheme.colors.textSecondary};
`;

const LogoutBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border: 1px solid ${adminTheme.colors.border};
  border-radius: 4px;
  background: none;
  cursor: pointer;
  font-size: 12px;
  color: ${adminTheme.colors.textSecondary};

  &:hover {
    background: #f8f9fa;
    color: ${adminTheme.colors.danger};
    border-color: ${adminTheme.colors.danger};
  }
`;

function getBreadcrumb(pathname: string): string {
  const parts = pathname.replace('/panel', '').split('/').filter(Boolean);
  if (parts.length === 0) return 'Dashboard';
  const labels: Record<string, string> = {
    components: 'Components',
    fluids: 'Fluids',
    rfq: 'RFQ Pipeline',
    templates: 'Templates',
  };
  return parts.map((p, i) => labels[p] || (i > 0 ? `#${p}` : p)).join(' / ');
}

interface AdminHeaderProps {
  username: string;
  onLogout: () => void;
}

export const AdminHeader: React.FC<AdminHeaderProps> = ({ username, onLogout }) => {
  const location = useLocation();
  const crumb = getBreadcrumb(location.pathname);

  return (
    <HeaderContainer>
      <Breadcrumb>
        Admin / <span>{crumb}</span>
      </Breadcrumb>
      <UserArea>
        <Username>{username}</Username>
        <LogoutBtn onClick={onLogout}>
          <Icon path={mdiLogout} size={0.55} />
          Logout
        </LogoutBtn>
      </UserArea>
    </HeaderContainer>
  );
};
